import { isEmpty } from 'lodash';

export const isNotEmpty = (value?: any) => !isEmpty(value);
